import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import CommentPost from 'flarum/forum/components/CommentPost';
import Pdf from 'jspdf';
import html2canvas from 'html2canvas';
import dompurify from 'dompurify'
import { saveAs } from 'file-saver';


app.initializers.add('justoverclock/export-post-to-pdf', () => {
  extend(CommentPost.prototype, 'oncreate', function () {
    const pdf = new Pdf('p', 'pt', 'a4');
    const language = app.translator.getLocale();
    console.log(language)
    const htmlElement = this.element.querySelector('.Post-body')
    const pdfButton = this.element.querySelector('.export-to-pdf-button')
    const codeScreenshotBtn = this.element.querySelector('.take-code-screenshot')
    const postID = this.attrs.post.id()

    if (language === 'pl') {
      const saveToPdf = () => {
        const htmlElement = this.element.querySelector('.Post-body');
        const printWindow = window.open('', '_blank');
        printWindow.document.open();
        printWindow.document.write(`
        <html>
        <head>
          <title>Post PDF</title>
          <meta charset="UTF-8">
          <style>
            @page {
              size: A4;
              margin: 0;
            }
            body {
              margin: 0;
              font-family: 'Noto Sans', sans-serif;
            }
            .pdf-content {
              padding: 20px;
            }
          </style>
          <link href="https://fonts.googleapis.com/css2?family=Noto+Sans&display=swap" rel="stylesheet">
        </head>
        <body>
          <div class="pdf-content">${htmlElement.innerHTML}</div>
        </body>
        </html>
      `);
        printWindow.document.close();

        printWindow.onload = () => {
          printWindow.print();
          printWindow.onafterprint = () => {
            printWindow.close();
          };
        };
      };

      pdfButton.addEventListener('click', saveToPdf)
    } else {
      const saveToPdf = async () => {
        pdf.html(htmlElement, {
          autoPaging: true,
          scale: 1,
          width: 550,
          windowWidth: 550,
          callback: function(pdf) {
            pdf.save(`post-${postID}.pdf`);
          },
          x: 20,
          y: 30
        });
      }



      const codeElement = this.element.querySelectorAll('code')[0];

      if (codeElement) {
        html2canvas(codeElement).then(canvas => {
          codeScreenshotBtn.addEventListener('click', () => {
            canvas.toBlob(function(blob) {
              saveAs(blob, "screenshot.png");
            });
          })
        });
      }

      pdfButton.addEventListener('click', saveToPdf)
    }

  })
  extend(CommentPost.prototype, 'footerItems', function (items) {
    items.add(
      'pdf-button-export',
       <div className="pdf-screen-container">
         <button className="Button export-to-pdf-button" title={app.translator.trans("justoverclock-export-post-to-pdf.forum.exportToPdf")}><i className="far fa-file-pdf pdfexport"></i>Pdf</button>
         <button className="Button take-code-screenshot" title={app.translator.trans("justoverclock-export-post-to-pdf.forum.codeScreenshot")}><i className="fas fa-code"></i></button>
       </div>
      );
  });
});
